import trim from 'lodash/trim';

export class HtmlDoc {
  static fromPartialHtml(partialHtml) {
    return new this(`
      <!DOCTYPE html>
      <html>
        <body>
          ${partialHtml}
        </body>
      </html>
    `);
  }

  static getParentTagNode(textNode, tags = []) {
    let current = textNode;
    while (current.parentNode) {
      if (tags.includes(current.parentNode.tagName)) {
        return current.parentNode;
      }

      current = current.parentNode;
    }

    return null;
  }

  constructor(html) {
    this._doc = new DOMParser().parseFromString(html, 'text/html');
  }

  selectByXpath(xpathStr) {
    const doc = this._doc;
    const result = doc.evaluate(xpathStr, doc, null, XPathResult.ANY_TYPE, null);

    let node = result.iterateNext();

    const nodes = [];

    while (node) {
      nodes.push(node);
      node = result.iterateNext();
    }

    return nodes;
  }

  getTextNodes() {
    const textNodeXpath = '//body//*[not(self::style or self::script)]//text()';
    return this.selectByXpath(textNodeXpath).filter((node) => trim(node.nodeValue).length > 0);
  }

  getPureText() {
    return this.getTextNodes()
      .map((node) => node.nodeValue)
      .join('');
  }

  eachChar(callback) {
    this.getTextNodes().reduce((charOffset, textNode) => {
      const text = textNode.nodeValue;

      for (let i = 0; i < text.length; i++) {
        callback(charOffset + i, text[i], textNode);
      }

      return charOffset + text.length;
    }, 0);
  }

  createTextNode(text) {
    return this._doc.createTextNode(text);
  }

  createElement(tagName, { attributes = {}, text = null } = {}) {
    const elem = this._doc.createElement(tagName);

    Object.entries(attributes).forEach(([attrKey, attrVal]) => {
      elem.setAttribute(attrKey, attrVal);
    });

    if (text) {
      elem.textContent = text;
    }

    return elem;
  }

  toString() {
    const serializer = new XMLSerializer();
    return serializer.serializeToString(this._doc);
  }

  toPartialString() {
    const bodyNode = this.selectByXpath('//body')[0];

    if (!bodyNode) {
      return '';
    }

    return trim(bodyNode.innerHTML);
  }
}
